import React from 'react';
import PropTypes from 'prop-types';
import { ErrorBoundary } from 'react-error-boundary';
import Icon, { IconSizes } from '../../../components/foundations/Icon';
import css from './ArtifactErrorBoundary.css';

const ErrorFallback = () => (
    <div className={css.artifactError}>
        <Icon name="alert-triangle" size={IconSizes.MEDIUM} />
        <div className={css.artifactErrorText}>
            <div className={css.artifactErrorTitle}>Artifact failed to render</div>
            <div className={css.artifactErrorSubtitle}>The artifact configuration is invalid.</div>
        </div>
    </div>
);

const handleArtifactError = error => {
    console.error('Artifact render failed:', error);
};

const ArtifactErrorBoundary = ({ children }) => (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleArtifactError}>
        {children}
    </ErrorBoundary>
);

ArtifactErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ArtifactErrorBoundary;
